import React, {PureComponent} from "react"
import {PerksAndPerksGoMetrics} from "@irati/admin/types"
import {H3} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

import {ActivityBlockWrapper, CardWrapper} from "../../styled/styled"
import SavingsItem from "../../DataItem"
import ShareLink from "../../../ShareLink"

interface Props {
  perksAndPerksGoMetrics: PerksAndPerksGoMetrics
}

class PerksSavingsBlock extends PureComponent<Props> {
  render() {
    const {perksAndPerksGoMetrics} = this.props
    const {redemption_count} = perksAndPerksGoMetrics

    return (
      <CardWrapper>
        <Flex justifyContent="space-between">
          <H3>
            <FormattedMessage id="admin.reporting.perksActivityBlock.title" />
          </H3>
          <ShareLink report="perksSavingsBlock" />
        </Flex>
        <ActivityBlockWrapper id="perksSavingsBlock">
          <SavingsItem dataItem={redemption_count} label="admin.reporting.perksSavingsBlock.redemptionsToDate" />
        </ActivityBlockWrapper>
      </CardWrapper>
    )
  }
}

export default PerksSavingsBlock
